// ===========================================
// Save / Reset only with the write permission (roles 1b §5.15)
// ===========================================
// The settings router gates every mutation on `system_settings.write` (a method-aware gate,
// adminSettings.routes.ts); the calendar event colours save through the school settings route
// (`school_setup.write`). A login with read only sees the values and this line instead of buttons
// that would 403.

import type { ReactNode } from 'react';
import { Typography } from '@mui/material';
import { usePermissions } from '../../../hooks/usePermissions';

// Each line names the role editor's own tick-box, so the reader knows what to ask for (/qa step 6 L4).
export const SETTINGS_VIEW_ONLY = 'View only: changing these settings needs System Settings (edit) access.';
export const SCHOOL_SETUP_VIEW_ONLY = 'View only: changing these needs Terms, Locations & Rooms (edit) access.';

export default function SettingsWriteGate({
  resource = 'system_settings',
  fallback,
  children,
}: {
  resource?: 'system_settings' | 'school_setup';
  /** What a read-only login sees instead; defaults to the "View only" line. `null` = nothing. */
  fallback?: ReactNode;
  children: ReactNode;
}) {
  const { can } = usePermissions();
  if (can(resource, 'write')) return <>{children}</>;
  if (fallback !== undefined) return <>{fallback}</>;
  return (
    <Typography variant="body2" color="text.secondary" sx={{ textAlign: 'right' }}>
      {resource === 'school_setup' ? SCHOOL_SETUP_VIEW_ONLY : SETTINGS_VIEW_ONLY}
    </Typography>
  );
}
